/* A bare code the pipeline stamped, e.g. `no_catalog_item`; prose has spaces. */
const CODE_SHAPE = /^[A-Za-z0-9]+(?:_+[A-Za-z0-9]+)+$/;

/**
 * Display text for an issue reason: `held_for_operator` reads "held for
 * operator". Only the shown text changes; the code itself stays as sent, so
 * filters, URLs and the API keep the underscores. Prose passes through, so a
 * SKU such as `ABC_123` inside a sentence is left alone.
 */
export function issueDisplayLabel(reason: string): string {
  const trimmed = reason.trim();

  return CODE_SHAPE.test(trimmed) ? trimmed.replace(/_+/g, ' ') : reason;
}
